import React from 'react';
import styled, { ThemeProps } from 'styled-components';
import { ThemeInterface } from '@westwing/ui-kit/Theme';
import { getClassName } from 'SharedHelpers/className';
import { useFeatureToggle } from 'AppShell/hooks';

interface StyledSignupOverlayWrapperProps extends ThemeProps<ThemeInterface> {
    isOpen: boolean;
}

export const StyledSignupOverlayWrapper = styled.div<StyledSignupOverlayWrapperProps>`
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    color: ${props => props.theme.colors.charcoal100};
    background-color: ${props => props.theme.colors.white};
    font-size: 1rem;
    font-family: 'Brandon Grotesque Regular', ${props => props.theme.fonts.fontBrandonRegular};
    display: ${props => (props.isOpen ? 'block' : 'none')};

    & * {
        box-sizing: border-box;
    }

    & ul,
    & ol {
        list-style: none;
        padding-left: 0;
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0;
        margin-inline-end: 0;
        padding-inline-start: 0;
    }

    & a {
        color: ${props => props.theme.colors.charcoal100};
    }

    & label {
        padding: 0;
        white-space: normal;
    }
`;

interface SignupOverlayWrapperProps {
    isOpen: boolean;
}

const SignupOverlayWrapper: React.FunctionComponent<SignupOverlayWrapperProps> = ({ children, isOpen }) => {
    const { passwordlessVariant = 'A' } = useFeatureToggle();
    const classes = getClassName(['qa-signup-overlay', passwordlessVariant === 'B' && 'qa-passwordless']);

    return (
        <StyledSignupOverlayWrapper isOpen={isOpen} className={classes}>
            {children}
        </StyledSignupOverlayWrapper>
    );
};

export default SignupOverlayWrapper;
